import { useEffect, useState } from "react";
import { OrderCommand } from "../../../../../services/command";
import {
  Card,
  CardContent,
  CircularProgress,
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TableBody,
  Grid,
  Link,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { UCL } from "../userOrderProductDetails.classes";

function UserCrossShipmentList({ shipment }: any) {
  const [data, setData] = useState<any>();
  const [loading, setLoading] = useState(true);
  const { t } = useTranslation();

  useEffect(() => {
    OrderCommand.GetCrossShipmentList(shipment.shippingListId)
      .then((res: any) => {
        setData(res);
      })
      .finally(() => setLoading(false));
  }, []);

  return data ? (
    <Card className={UCL.rootCard} sx={{ minWidth: 275, margin: 2 }}>
      <CardContent className={UCL.content}>
        <TableContainer className={UCL.tableContainer} component={Paper}>
          <Table className={UCL.table}>
            <TableHead>
              <TableRow className={UCL.headRow}>
                <TableCell className={UCL.headCellId}>
                  <div style={{ display: "flex", justifyContent: "start" }}>
                    <p style={{ marginLeft: "1rem" }}>
                      {t("orderDetail.shippingListId")}
                    </p>{" "}
                  </div>
                </TableCell>
                <TableCell className={UCL.headCellNo}>
                  <p style={{ marginLeft: "1rem" }}>
                    {t("orderDetail.shippingListNo")}
                  </p>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data.map((row: any, index: any) => (
                <TableRow className={UCL.bodyRow} key={index}>
                  <TableCell className={UCL.bodyCellId} style={{ textAlign: "left" }}>
                    <Link
                      href={`/orderDetail?ShippingListId=${row.shippingListId}`}
                      target="_blank"
                    >
                      {row.shippingListId}
                    </Link>
                  </TableCell>
                  <TableCell className={UCL.bodyCellNo} style={{ textAlign: "left" }}>
                    {row.shippingListNo}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </CardContent>
    </Card>
  ) : loading ? (
    <Grid
      className={UCL.loadingGrid}
      container
      style={{ height: "100%" }}
      alignItems="center"
      justifyContent="center"
    >
      <div
        className={UCL.loadingInner}
        style={{
          textAlign: "center",
          position: "relative",
          pointerEvents: "none",
        }}
      >
        <CircularProgress size={80} />
      </div>
    </Grid>
  ) : (
    <div
      className={UCL.emptyWrap}
      style={{
        color: "orange",
        display: "flex",
        justifyContent: "center",
        marginTop: "2rem",
      }}
    >
      <h2 className={UCL.emptyTitle} style={{ marginLeft: "2rem" }}>
        {t("orderDetail.crossShippmentNotFound")}
      </h2>
    </div>
  );
}

export default UserCrossShipmentList;
